import {HttpModelConverter} from '../../../../../../core/converter/httpModel.converter';
import {PurchaseOrderModel} from '../purchaseOrder.model';
import {PurchaseOrderSummaryConverter} from './purchaseOrderSummary.converter';
import {SaleSummaryConverter} from '../../../../../api/entity/converter/saleSummary.converter';
import {Injectable} from '@angular/core';

@Injectable({providedIn: 'root'})
export class PurchaseOrderConverter extends HttpModelConverter<PurchaseOrderModel> {

    constructor(private summaryConverter: PurchaseOrderSummaryConverter,
                private saleConverter: SaleSummaryConverter) {
        super();
    }

    protected createInstance(): PurchaseOrderModel {
        return new PurchaseOrderModel();
    }

    protected enrichObject(result: PurchaseOrderModel, src: PurchaseOrderModel) {

        result.summary = this.summaryConverter.convert(src.summary);
        result.sale = this.saleConverter.convert(src.sale);
    }

}
